const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/cis4m.ts';
import { KEY_METAKAT_DATA, makeSelectFormMetaKatData } from '@cistec/common_web/components/Forms/store';
import { loadFromMetaKatForCIS4m } from 'App/actions/metakat';
import { useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';

// HOOKS

export function useCIS4FormMetaKatData(iCode: string, lookup: boolean = true) {
    return useRemoteData2('form', {
        canRequest: !!iCode,
        request: dispatch => dispatch(loadFromMetaKatForCIS4m(iCode)),
        keys: [KEY_METAKAT_DATA, iCode],
        select: makeSelectFormMetaKatData(iCode),
    });
}
